// /* eslint-disable @typescript-eslint/no-unused-vars */
// import { IconCircle, IconCircleCheckFilled, IconX } from "@tabler/icons-react";
// import { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import Input from "../../../components/Input";
// import { useBulkPdfGenerateMutation } from "../../../apis/bulkPdfApis";
// import {
//   useNaqelBulkLabelPrintMutation,
//   useNaqelJobStatus,
// } from "../../../apis/naqelApis";
// import toast from "react-hot-toast";
// import { PDFDocument } from "pdf-lib";
// import {
//   useAramexBulkLabelPrintMutation,
//   useAramexJobStatus,
// } from "../../../apis/aramexApis";

// type BulkPdfModalProps = {
//   open: boolean;
//   onClose: () => void;
//   orders: any[];
//   companyName?: string; 
// };

// const mergeAndOpenPDFs = async (labels: string[]) => {
//   try {
//     const mergedPdf = await PDFDocument.create();

//     for (const labelData of labels) {
//       try {
//         if (labelData.startsWith("http")) {
//           const res = await fetch(labelData);
//           if (!res.ok) throw new Error("Failed to fetch label URL");
//           const buffer = await res.arrayBuffer();
//           const pdf = await PDFDocument.load(buffer);
//           const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
//           pages.forEach((p:any) => mergedPdf.addPage(p));
//           continue;
//         }

//         const base64 = labelData
//           .replace(/^data:application\/pdf;base64,/, "")
//           .replace(/\s/g, "");
//         const pdfBytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
//         const pdf = await PDFDocument.load(pdfBytes);
//         const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
//         pages.forEach((p:any) => mergedPdf.addPage(p));
//       } catch (err) {
//         console.error("❌ Error processing individual label:", err);
//       }
//     }

//     const mergedBytes = await mergedPdf.save();
//     if (!mergedBytes || mergedBytes.length === 0) throw new Error("Merged PDF is empty");

//     const blob = new Blob([new Uint8Array(mergedBytes)], { type: "application/pdf" });
//     const url = URL.createObjectURL(blob);
//     const newWindow = window.open(url, "_blank");
//     if (!newWindow) throw new Error("Popup blocked. Please allow popups for this site.");
//     newWindow.onload = () => newWindow.print();
//   } catch (error: any) {
//     console.error("❌ PDF merge failed:", error);
//     throw new Error(error.message || "Failed to generate merged PDF");
//   }
// };

// // Shared label-extraction logic — handles nested objects, arrays, URLs and base64
// const extractLabels = (labelResult: any): string[] => {
//   const labels: string[] = [];
//   const extract = (obj: any) => {
//     if (!obj) return;
//     if (typeof obj === "string") {
//       if (
//         obj.startsWith("http") ||
//         obj.startsWith("JVBERi0") ||
//         obj.startsWith("data:application/pdf")
//       ) {
//         labels.push(obj);
//       }
//       return;
//     }
//     if (Array.isArray(obj)) { obj.forEach(extract); return; }
//     if (typeof obj === "object") { Object.values(obj).forEach(extract); }
//   };
//   extract(labelResult);
//   return labels;
// };

// export default function BulkPdfModal({ open, onClose, orders, companyName = "" }: BulkPdfModalProps) {
//   const { register, handleSubmit } = useForm();

//   const [selectedSystem, setSelectedSystem] = useState<"default" | "3pl">("default");

//   // ── Naqel state ───────────────────────────────────────────────────────────────
//   const [naqelJobId, setNaqelJobId] = useState<string | undefined>();
//   const { mutate: naqelLabelMutate, isPending: isNaqelPending } = useNaqelBulkLabelPrintMutation();
//   const { data: naqelJob } = useNaqelJobStatus(naqelJobId);

//   // ── Aramex state ──────────────────────────────────────────────────────────────
//   const [aramexJobId, setAramexJobId] = useState<string | undefined>();
//   const { mutate: aramexLabelMutate, isPending: isAramexPending } = useAramexBulkLabelPrintMutation();
//   const { data: aramexJob } = useAramexJobStatus(aramexJobId);

//   const { mutate, isPending } = useBulkPdfGenerateMutation();

//   // ── Poll Naqel job ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const handle = async () => {
//       if (!naqelJobId) return;
//       if (naqelJob?.status === "FAILED") {
//         toast.error(naqelJob?.meta?.error || "Naqel label print failed. Please try again.");
//         setNaqelJobId(undefined);
//         return;
//       }
//       if (naqelJob?.status !== "COMPLETED") return;

//       const labels = extractLabels(naqelJob?.meta?.labelResult);
//       if (labels.length === 0) {
//         toast.error("No valid labels found in Naqel response");
//         setNaqelJobId(undefined);
//         return;
//       }
//       try {
//         await mergeAndOpenPDFs(labels);
//       } catch (err: any) {
//         toast.error(err.message || "Failed to open Naqel labels");
//       }
//       setNaqelJobId(undefined);
//       onClose();
//     };
//     handle();
//   }, [naqelJob, naqelJobId, onClose]);

//   // ── Poll Aramex job ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     const handle = async () => {
//       if (!aramexJobId) return;
//       if (aramexJob?.status === "FAILED") {
//         toast.error(aramexJob?.meta?.error || "Aramex label print failed. Please try again.");
//         setAramexJobId(undefined);
//         return;
//       }
//       if (aramexJob?.status !== "COMPLETED") return;

//       const meta = aramexJob?.meta || {};

//       if (meta.mergedLabelBase64) {
//         try {
//           await mergeAndOpenPDFs([meta.mergedLabelBase64]);
//         } catch (err: any) {
//           toast.error(err.message || "Failed to open merged Aramex PDF");
//         }
//         setAramexJobId(undefined);
//         onClose();
//         return;
//       }

//       const labelUrls: string[] = Array.isArray(meta.labelUrls) ? meta.labelUrls : [];
//       const fromResult = extractLabels(meta.labelResult);
//       const labels = labelUrls.length > 0 ? labelUrls : fromResult;

//       if (labels.length === 0) {
//         toast.error("No valid Aramex labels found in response");
//         setAramexJobId(undefined);
//         return;
//       }

//       labels.forEach((url) => window.open(url, "_blank"));
//       setAramexJobId(undefined);
//       onClose();
//     };
//     handle();
//   }, [aramexJob, aramexJobId, onClose]);

//   // ── Generate handler 
//   const handleGenerate = () => {
//     const orderIds = orders?.map((o: any) => o.id);
//     if (!orderIds || orderIds.length === 0) {
//       toast.error("Please select at least one order");
//       return;
//     }

//     if (selectedSystem === "3pl") {
//       const isAramex = companyName.includes("aramex");
//       const isNaqel = companyName.includes("naqel");

//       if (isAramex) {
//         aramexLabelMutate(
//           { orderIds, labelFormat: "PDF", labelsize: "4x6" },
//           {
//             onSuccess: (res: any) => {
//               const jobId = res?.data?.jobId;
//               if (!jobId) { toast.error("Failed to create Aramex label job"); return; }
//               setAramexJobId(jobId);
//             },
//             onError: () => toast.error("Failed to start Aramex label generation"),
//           }
//         );
//         return;
//       }

//       if (isNaqel) {
//         naqelLabelMutate(
//           { orderIds, labelFormat: "PDF", labelsize: "4x6" },
//           {
//             onSuccess: (res: any) => {
//               const jobId = res?.data?.jobId;
//               if (!jobId) { toast.error("Failed to create Naqel label job"); return; }
//               setNaqelJobId(jobId);
//             },
//             onError: () => toast.error("Failed to start Naqel label generation"),
//           }
//         );
//         return;
//       }

//       toast.error("Please select a 3PL company before printing labels");
//       return;
//     }

//     mutate(
//       { orderIds, system: selectedSystem },
//       {
//         onSuccess: () => { toast.success("PDF generation started"); onClose(); },
//         onError: () => toast.error("Failed to generate PDF"),
//       }
//     );
//   };

//   if (!open) return null;

//   const isProcessing = isPending || isNaqelPending || isAramexPending;
//   const isPolling =
//     (!!naqelJobId && naqelJob?.status !== "COMPLETED" && naqelJob?.status !== "FAILED") ||
//     (!!aramexJobId && aramexJob?.status !== "COMPLETED" && aramexJob?.status !== "FAILED");

//   const pollingLabel = aramexJobId ? "Generating Aramex labels…" : "Generating Naqel labels…";
//   const is3PL = selectedSystem === "3pl";
//   const is3PLLabel = companyName.includes("aramex")
//     ? "Aramex"
//     : companyName.includes("naqel")
//     ? "Naqel Express"
//     : "3PL";

//   return (
//     <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
//       <div className="rounded-2xl">
//         {/* ── Header ── */}
//         <div className="flex items-center">
//           <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px]">
//             <h2 className="text-2xl">PDF Generate</h2>
//           </div>
//           <div className="relative">
//             <svg xmlns="http://www.w3.org/2000/svg" width={38} height={37} viewBox="0 0 38 37" fill="none" className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]">
//               <path d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z" fill="#F7F6F2" />
//             </svg>
//             <button onClick={onClose} className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0">
//               <IconX size={20} />
//             </button>
//           </div>
//         </div>

//         {/* ── Body ── */}
//         <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//           <div className="w-[655px]">
//             {/* Polling status banner */}
//             {isPolling && (
//               <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-xl px-4 py-3 mb-4 text-[#FBD037] text-sm">
//                 <svg className="animate-spin h-4 w-4 flex-shrink-0" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                 </svg>
//                 {pollingLabel} Labels will open automatically when ready.
//               </div>
//             )}

//             {/* Failed banners */}
//             {naqelJob?.status === "FAILED" && naqelJobId && (
//               <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-xl px-4 py-3 mb-4 text-red-700 text-sm">
//                 Naqel label print failed. Please check the orders have been forwarded to Naqel first.
//               </div>
//             )}
//             {aramexJob?.status === "FAILED" && aramexJobId && (
//               <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-xl px-4 py-3 mb-4 text-red-700 text-sm">
//                 Aramex label print failed. Please check the orders have been forwarded to Aramex first.
//               </div>
//             )}

//             {/* System selector */}
//             <div>
//               <p className="text-sm font-medium mb-4">
//                 Selected Orders: <span className="font-bold text-[#FBD037]">{orders?.length}</span>
//               </p>
//               <p className="text-sm font-medium mb-2">Select System</p>
//               <div className="grid grid-cols-2 gap-4">
//                 <div
//                   onClick={() => !isPolling && setSelectedSystem("default")}
//                   className={`border rounded-lg p-2 flex items-start space-x-2 cursor-pointer ${selectedSystem === "default" ? "bg-[#FBD037]/10 border-[#FBD037]" : "bg-transparent border-[#D8D8D8]"} ${isPolling ? "opacity-50 cursor-not-allowed" : ""}`}
//                 >
//                   <div>{selectedSystem === "default" ? <IconCircleCheckFilled className="text-[#FBD037]" /> : <IconCircle className="text-black/60" />}</div>
//                   <div>
//                     <p className="text-base font-medium">Default Label Print</p>
//                     <p className="text-sm text-[#212121]/80">Default System AWB</p>
//                   </div>
//                 </div>

//                 <div
//                   onClick={() => !isPolling && setSelectedSystem("3pl")}
//                   className={`border rounded-lg p-2 flex items-start space-x-2 cursor-pointer ${selectedSystem === "3pl" ? "bg-[#FBD037]/10 border-[#FBD037]" : "bg-transparent border-[#D8D8D8]"} ${isPolling ? "opacity-50 cursor-not-allowed" : ""}`}
//                 >
//                   <div>{selectedSystem === "3pl" ? <IconCircleCheckFilled className="text-[#FBD037]" /> : <IconCircle className="text-black/60" />}</div>
//                   <div>
//                     <p className="text-base font-medium">3PL Label Print</p>
//                     <p className="text-sm text-[#212121]/80">Forwarded AWB ({is3PL ? is3PLLabel : "3PL"})</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <Input title="Size" name="size" value="4 x 6 inches" className="" register={register} disabled />
//           </div>
//         </div>

//         {/* ── Footer ── */}
//         <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
//           <button
//             onClick={handleSubmit(handleGenerate)}
//             disabled={isProcessing || isPolling}
//             className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed disabled:bg-gray-400 cursor-pointer text-sm font-medium"
//           >
//             {isProcessing || isPolling ? (
//               <>
//                 <svg className="animate-spin h-4 w-4 mr-1" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                 </svg>
//                 {isPolling ? "Generating labels..." : "Generating..."}
//               </>
//             ) : (
//               "Generate"
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconCircle, IconCircleCheckFilled, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../components/Input";
import { useBulkPdfGenerateMutation } from "../../../apis/bulkPdfApis";
import {
  useNaqelBulkLabelPrintMutation,
  useNaqelJobStatus,
} from "../../../apis/naqelApis";
import toast from "react-hot-toast";
import { PDFDocument } from "pdf-lib";
import {
  useAramexBulkLabelPrintMutation,
  useAramexJobStatus,
} from "../../../apis/aramexApis";

type BulkPdfModalProps = {
  open: boolean;
  onClose: () => void;
  orders: any[];
  companyName?: string;
};

const mergeAndOpenPDFs = async (labels: string[]) => {
  try {
    const mergedPdf = await PDFDocument.create();

    for (const labelData of labels) {
      try {
        if (labelData.startsWith("http")) {
          const res = await fetch(labelData);
          if (!res.ok) throw new Error("Failed to fetch label URL");
          const buffer = await res.arrayBuffer();
          const pdf = await PDFDocument.load(buffer);
          const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          pages.forEach((p: any) => mergedPdf.addPage(p));
          continue;
        }

        const base64 = labelData
          .replace(/^data:application\/pdf;base64,/, "")
          .replace(/\s/g, "");
        const pdfBytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
        const pdf = await PDFDocument.load(pdfBytes);
        const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        pages.forEach((p: any) => mergedPdf.addPage(p));
      } catch (err) {
        console.error("❌ Error processing individual label:", err);
      }
    }

    const mergedBytes = await mergedPdf.save();
    if (!mergedBytes || mergedBytes.length === 0)
      throw new Error("Merged PDF is empty");

    const blob = new Blob([new Uint8Array(mergedBytes)], {
      type: "application/pdf",
    });
    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (!newWindow)
      throw new Error("Popup blocked. Please allow popups for this site.");
    newWindow.onload = () => newWindow.print();
  } catch (error: any) {
    console.error("❌ PDF merge failed:", error);
    throw new Error(error.message || "Failed to generate merged PDF");
  }
};

const extractLabels = (labelResult: any): string[] => {
  const labels: string[] = [];
  const extract = (obj: any) => {
    if (!obj) return;
    if (typeof obj === "string") {
      if (
        obj.startsWith("http") ||
        obj.startsWith("JVBERi0") ||
        obj.startsWith("data:application/pdf")
      ) {
        labels.push(obj);
      }
      return;
    }
    if (Array.isArray(obj)) { obj.forEach(extract); return; }
    if (typeof obj === "object") { Object.values(obj).forEach(extract); }
  };
  extract(labelResult);
  return labels;
};

export default function BulkPdfModal({
  open,
  onClose,
  orders,
  companyName = "",
}: BulkPdfModalProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      noOfPieces: 1,
    },
  });

  // If companyName is provided (3PL label print context) → default to "3pl"
  const is3PLContext = !!companyName;
  const [selectedSystem, setSelectedSystem] = useState<"default" | "3pl">(
    is3PLContext ? "3pl" : "default"
  );

  // ── Naqel ─────────────────────────────────────────────────────────────────────
  const [naqelJobId, setNaqelJobId] = useState<string | undefined>();
  const { mutate: naqelLabelMutate, isPending: isNaqelPending } =
    useNaqelBulkLabelPrintMutation();
  const { data: naqelJob } = useNaqelJobStatus(naqelJobId);

  // ── Aramex ────────────────────────────────────────────────────────────────────
  const [aramexJobId, setAramexJobId] = useState<string | undefined>();
  const { mutate: aramexLabelMutate, isPending: isAramexPending } =
    useAramexBulkLabelPrintMutation();
  const { data: aramexJob } = useAramexJobStatus(aramexJobId);

  const { mutate, isPending } = useBulkPdfGenerateMutation();

  // ── Poll Naqel ────────────────────────────────────────────────────────────────
  useEffect(() => {
    const handle = async () => {
      if (!naqelJobId) return;
      if (naqelJob?.status === "FAILED") {
        toast.error(naqelJob?.meta?.error || "Naqel label print failed. Please try again.");
        setNaqelJobId(undefined);
        return;
      }
      if (naqelJob?.status !== "COMPLETED") return;
      const labels = extractLabels(naqelJob?.meta?.labelResult);
      if (labels.length === 0) {
        toast.error("No valid labels found in Naqel response");
        setNaqelJobId(undefined);
        return;
      }
      try { await mergeAndOpenPDFs(labels); } catch (err: any) {
        toast.error(err.message || "Failed to open Naqel labels");
      }
      setNaqelJobId(undefined);
      onClose();
    };
    handle();
  }, [naqelJob, naqelJobId, onClose]);

  // ── Poll Aramex ───────────────────────────────────────────────────────────────
  useEffect(() => {
    const handle = async () => {
      if (!aramexJobId) return;
      if (aramexJob?.status === "FAILED") {
        toast.error(aramexJob?.meta?.error || "Aramex label print failed. Please try again.");
        setAramexJobId(undefined);
        return;
      }
      if (aramexJob?.status !== "COMPLETED") return;
      const meta = aramexJob?.meta || {};
      if (meta.mergedLabelBase64) {
        try { await mergeAndOpenPDFs([meta.mergedLabelBase64]); } catch (err: any) {
          toast.error(err.message || "Failed to open merged Aramex PDF");
        }
        setAramexJobId(undefined);
        onClose();
        return;
      }
      const labelUrls: string[] = Array.isArray(meta.labelUrls) ? meta.labelUrls : [];
      const fromResult = extractLabels(meta.labelResult);
      const labels = labelUrls.length > 0 ? labelUrls : fromResult;
      if (labels.length === 0) {
        toast.error("No valid Aramex labels found in response");
        setAramexJobId(undefined);
        return;
      }
      labels.forEach((url) => window.open(url, "_blank"));
      setAramexJobId(undefined);
      onClose();
    };
    handle();
  }, [aramexJob, aramexJobId, onClose]);

  // ── Generate ──────────────────────────────────────────────────────────────────
  const handleGenerate = (data: any) => {
    const orderIds = orders?.map((o: any) => o.id);
    if (!orderIds || orderIds.length === 0) {
      toast.error("Please select at least one order");
      return;
    }

    if (selectedSystem === "3pl") {
      const isAramex = companyName.includes("aramex");
      const isNaqel = companyName.includes("naqel");

      if (isAramex) {
        aramexLabelMutate(
          { orderIds, labelFormat: "PDF", labelsize: "4x6" },
          {
            onSuccess: (res: any) => {
              const jobId = res?.data?.jobId;
              if (!jobId) { toast.error("Failed to create Aramex label job"); return; }
              setAramexJobId(jobId);
            },
            onError: () => toast.error("Failed to start Aramex label generation"),
          }
        );
        return;
      }

      if (isNaqel) {
        naqelLabelMutate(
          { orderIds, labelFormat: "PDF", labelsize: "4x6" },
          {
            onSuccess: (res: any) => {
              const jobId = res?.data?.jobId;
              if (!jobId) { toast.error("Failed to create Naqel label job"); return; }
              setNaqelJobId(jobId);
            },
            onError: () => toast.error("Failed to start Naqel label generation"),
          }
        );
        return;
      }

      toast.error("Please select a 3PL company before printing labels");
      return;
    }

    // Default system
    mutate(
      { orderIds, system: selectedSystem, noOfPieces: data?.noOfPieces },
      {
        onSuccess: () => { toast.success("PDF generation started"); onClose(); },
        onError: () => toast.error("Failed to generate PDF"),
      }
    );
  };

  if (!open) return null;

  const isProcessing = isPending || isNaqelPending || isAramexPending;
  const isPolling =
    (!!naqelJobId && naqelJob?.status !== "COMPLETED" && naqelJob?.status !== "FAILED") ||
    (!!aramexJobId && aramexJob?.status !== "COMPLETED" && aramexJob?.status !== "FAILED");

  const pollingLabel = aramexJobId ? "Generating Aramex labels…" : "Generating Naqel labels…";

  const is3PLLabel = companyName.includes("aramex")
    ? "Aramex"
    : companyName.includes("naqel")
    ? "Naqel Express"
    : "3PL";

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="rounded-2xl">
        {/* ── Header ── */}
        <div className="flex items-center">
          <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px]">
            <h2 className="text-2xl">PDF Generate</h2>
          </div>
          <div className="relative">
            <svg xmlns="http://www.w3.org/2000/svg" width={38} height={37} viewBox="0 0 38 37" fill="none" className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]">
              <path d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z" fill="#F7F6F2" />
            </svg>
            <button onClick={onClose} className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0">
              <IconX size={20} />
            </button>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
          <div className="w-[655px]">

            {/* Polling banner */}
            {isPolling && (
              <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-xl px-4 py-3 mb-4 text-[#FBD037] text-sm">
                <svg className="animate-spin h-4 w-4 flex-shrink-0" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                {pollingLabel} Labels will open automatically when ready.
              </div>
            )}

            {/* Failed banners */}
            {naqelJob?.status === "FAILED" && naqelJobId && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-xl px-4 py-3 mb-4 text-red-700 text-sm">
                Naqel label print failed. Please check the orders have been forwarded to Naqel first.
              </div>
            )}
            {aramexJob?.status === "FAILED" && aramexJobId && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-xl px-4 py-3 mb-4 text-red-700 text-sm">
                Aramex label print failed. Please check the orders have been forwarded to Aramex first.
              </div>
            )}

            {/* ── System Selector + Fields ── */}
            <div>
              <p className="text-sm font-medium mb-2">Select System</p>
              {/* Cards row */}
              <div className="grid grid-cols-2 gap-4 mb-4">

                {/* Default Card — hidden in 3PL context */}
                {!is3PLContext && (
                  <div
                    onClick={() => !isPolling && setSelectedSystem("default")}
                    className={`border rounded-lg p-2 flex items-start space-x-2 cursor-pointer transition-all ${
                      selectedSystem === "default"
                        ? "bg-[#FBD037]/10 border-[#FBD037]"
                        : "bg-transparent border-[#D8D8D8]"
                    } ${isPolling ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    <div>
                      {selectedSystem === "default" ? (
                        <IconCircleCheckFilled className="text-[#FBD037]" />
                      ) : (
                        <IconCircle className="text-black/60" />
                      )}
                    </div>
                    <div>
                      <p className="text-base font-medium">Default Label Print</p>
                      <p className="text-sm text-[#212121]/80">Default System AWB</p>
                    </div>
                  </div>
                )}

                {/* 3PL Card — full width when alone, half when with Default */}
                <div
                  onClick={() => !isPolling && setSelectedSystem("3pl")}
                  className={`border rounded-lg p-2 flex items-start space-x-2 cursor-pointer transition-all ${
                    is3PLContext ? "col-span-2" : ""
                  } ${
                    selectedSystem === "3pl"
                      ? "bg-[#FBD037]/10 border-[#FBD037]"
                      : "bg-transparent border-[#D8D8D8]"
                  } ${isPolling ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  <div>
                    {selectedSystem === "3pl" ? (
                      <IconCircleCheckFilled className="text-[#FBD037]" />
                    ) : (
                      <IconCircle className="text-black/60" />
                    )}
                  </div>
                  <div>
                    <p className="text-base font-medium">3PL Label Print</p>
                    <p className="text-sm text-[#212121]/80">
                      Forwarded AWB ({is3PLLabel})
                    </p>
                  </div>
                </div>
              </div>

              {/* Size + No. of Pieces — always same row */}
              <div className="grid grid-cols-2 gap-4">
                <Input
                  title="Size"
                  name="size"
                  value="4 x 6 inches"
                  className=""
                  register={register}
                  disabled
                />
                <Input
                  title="No. of Pieces"
                  name="noOfPieces"
                  type="number"
                  placeholder=""
                  className=""
                  register={register}
                  error={errors?.noOfPieces}
                  validation={{
                    required: "No. of pieces is required",
                    min: { value: 1, message: "At least 1 piece is required" },
                    max: { value: 9999, message: "Maximum allowed is 9999 pieces" },
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── Footer ── */}
        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
          <button
            onClick={handleSubmit(handleGenerate)}
            disabled={isProcessing || isPolling}
            className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed disabled:bg-gray-400 cursor-pointer text-sm font-medium"
          >
            {isProcessing || isPolling ? (
              <>
                <svg className="animate-spin h-4 w-4 mr-1" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                {isPolling ? "Generating labels..." : "Generating..."}
              </>
            ) : (
              "Generate"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}